import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'
import { PageTitle } from '../PageShell'
import styles from './FlowPanel.module.scss'

type FlowPanelProps = HTMLAttributes<HTMLDivElement>
type FlowPanelTitleProps = HTMLAttributes<HTMLHeadingElement>

export function FlowPanel({ className, children, ...props }: FlowPanelProps) {
  return (
    <div className={cn(styles['flow-panel'], 'flow-panel', className)} {...props}>
      {children}
    </div>
  )
}

export function FlowPanelTitle({ className, children, ...props }: FlowPanelTitleProps) {
  return (
    <PageTitle variant='responsive' className={cn('flow-panel-title', className)} {...props}>
      {children}
    </PageTitle>
  )
}

export function FlowPanelSurface({ className, children, ...props }: FlowPanelProps) {
  return (
    <div className={cn(styles['flow-panel-surface'], 'flow-panel-surface', 'shadow-card', className)} {...props}>
      {children}
    </div>
  )
}
